import React from "react";
import { usePopup } from "../../Context/PopupContext"; // Adjust the import path as necessary
import PopEnquiryForm from "./PopEnquiryForm"; // Your existing form component
import "./popup.css"; // Import your CSS for styling the popup
const Popup = () => {
  const { isOpen, closePopup } = usePopup();

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div className="popup-overlay-container w-100 h-100">
        <div className="popup-content" onClick={(e) => e.stopPropagation()}>
          <PopEnquiryForm />
        </div>
        <button className="popup-close" onClick={closePopup}>
          close
        </button>
      </div>
    </div>
  );
};

export default Popup;
